module.exports = __webpack_public_path__ + "static/media/nl.4624853d.svg";